import(/* webpackMode: "eager" */ "/usr/src/app/ops-portal/src/app/[lang]/loading.tsx")